<template>
  <div class="header-containder">
    <div class="header">
      <div class="menu-user-info">
        <div class="menu-icon" @click="collapse">
          <el-icon :size="20" :class="{
            'hide-menu-icon': isCollapse,
            'show-menu-icon': !isCollapse,
          }">
            <Fold />
          </el-icon>
        </div>
        <div class="route-user-info">
          <div class="route-logo">
            <div class="logo-name">{{ companyName }}</div>
            <bread></bread>
          </div>
          <!-- <el-link type="success" @click="logVisibale = true">Version 0.2.5</el-link> -->
          <div class="user-info">
            <el-dropdown placement="bottom" trigger="click">
              <span class="el-dropdown-link">
                <div class="user-img">
                  <img :src="format.responseUrlFormat(avatar, 'avatars')"/>
                </div>
                <div class="user-name">
                  {{ userName }}
                  <el-icon style="margin-left: 5px;" :size="20">
                    <CaretBottom />
                  </el-icon>
                </div>
              </span>
              <template #dropdown>
                <el-dropdown-menu class="user-dpd">
                  <el-dropdown-item>
                    <div @click="changeAvatar">更换头像</div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div @click="changePassWord">修改密码</div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div @click="loginOut">退出登录</div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
      </div>
      <tags></tags>
    </div>
    <change-pwd ref="changePwd" />
    <uploadFile ref="uploadFile" @uploadSuccess="uploadSuccess" />
    <el-dialog title="版本更新日志" v-model="logVisibale" width="900px" destroy-on-close draggable  show-close :close-on-click-modal="false">
      <el-divider>V1</el-divider>
      <el-timeline>
        <el-timeline-item timestamp="2025-09-12[V1.0]" placement="top">
          <el-card>
            发布新版本vue1.0;
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </el-dialog>
  </div>
</template>

<script setup>
import { CaretBottom, Fold } from '@element-plus/icons-vue'
import { computed } from 'vue'
import { useAppStore } from '@/store/app'

const useApp = useAppStore()

const isCollapse = computed(() => {
  return useApp.isCollapse
})
</script>

<script>
import changePwd from '@/components/changePwd.vue'
import uploadFile from '@/components/uploadFile.vue'
import bread from './bread.vue'
import tags from './tags.vue'
import { logout } from '@/api/auth'
import { updateAvatar } from "@/api/setting/user";
import { useRouteStore } from '@/store/route'

export default {
  components: { changePwd, uploadFile, bread, tags },
  data() {
    return {
      companyName: '七星臻选',//localStorage.getItem('X-UserName'),
      userName: localStorage.getItem('X-UserName'),
      avatar: localStorage.getItem('X-UserAvatar'),
      logVisibale: false,
    }
  },
  methods: {
    collapse() {
      const useApp = useAppStore()
      useApp.setShowLogo(false)
      setTimeout(() => {
        useApp.setIsCollapse(!useApp.isCollapse)
        setTimeout(() => {
          useApp.setShowLogo(true)
        }, 100)
      }, 0)
    },
    changeAvatar() {
      this.$refs.uploadFile.chooseFile('image', 'avatars')
    },
    uploadSuccess(path) {
      updateAvatar(JSON.stringify(path)).then(res => {
        localStorage.setItem('X-UserAvatar', res)
        this.avatar = res
      })
    },
    changePassWord() {
      this.$refs.changePwd.showCurrentForm(this.userName)
    },
    loginOut() {
      logout({}).then(() => {
        localStorage.setItem('X-Token', '')
        localStorage.setItem('X-UserKey', '')
        localStorage.setItem('X-UserName', '')
        localStorage.setItem('X-UserAvatar', '')
        localStorage.setItem('X-Organization', '')
        localStorage.setItem('X-OrgType', '')
        localStorage.setItem('X-OrgName', '')
        localStorage.setItem('X-Routes', '')
        const useRoute = useRouteStore()
        useRoute.setRouters([])
        this.$router.push('/login')
      })
    },
  },
  mounted() {
  },
}
</script>
<style lang="scss" scoped>
.header-containder {
  background: #f6f6f6;
  // box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);

  .header {
    height: 100%;

    .menu-user-info {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      // tag-active
      background: var(--head-bg);

      .menu-icon {
        height: 50px;
        width: 50px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          display: inline-block;
          color: black;
          font-size: 27px;
        }

        .show-menu-icon {
          transform: rotate(0deg);
          transition: all 0.3s linear;
        }

        .hide-menu-icon {
          transform: rotate(180deg);
          transition: all 0.3s linear;
        }

        &:hover {
          box-shadow: 0px 0px 10px 1px #eee inset;
        }
      }

      .route-user-info {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .route-logo {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;

          .logo-name {
            font-size: 18px;
            margin-left: 10px;
          }
        }

        .user-info {
          .el-dropdown-link {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            padding-right: 15px;
            cursor: pointer;
            user-select: none;

            .user-img {
              margin-right: 10px;

              img {
                width: 30px;
                height: 30px;
                border-radius: 50%;
              }
            }

            .user-name {
              font-size: 17px;
              color: black;
              display: flex;
              flex-direction: row;
              justify-content: flex-end;
              align-items: center;
            }
          }
        }
      }
    }
  }
}
</style>
